import { ComponentType } from 'react';
import DefaultTemplate from './DefaultTemplate';
import PincoTemplate from './PincoTemplate';
import LionOnePageTemplate from './LionOnePageTemplate';
import PayPageGateV1 from './PayPageGateV1';
import QuasiTemplate from './QuasiTemplate';
import { TemplateProps } from './types';
import { TemplateName, resolveTemplateName } from './templateNames';

/**
 * Name → component. The decision itself lives in `templateNames.ts`, so that analytics can reach
 * the same answer without importing this module and dragging the whole template tree with it.
 */
const COMPONENT_BY_NAME: Record<TemplateName, ComponentType<TemplateProps>> = {
  pinco: PincoTemplate,
  default: DefaultTemplate,
  onepage: LionOnePageTemplate,
  gatev1: PayPageGateV1,
  quasi: QuasiTemplate,
};

/**
 * Which screen this client gets: the quasi method has its own, then personal templates; everyone
 * else gets `PayPageGateV1`.
 */
export const resolveTemplate = (merchant?: string, paymentMethod?: string | null): ComponentType<TemplateProps> =>
  COMPONENT_BY_NAME[resolveTemplateName(merchant, paymentMethod)];

export { resolveTemplateName } from './templateNames';
export type { TemplateName } from './templateNames';
